import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ParentLayout from "./components/ParentLayout";
import InstallPrompt from "./components/InstallPrompt";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Pending from "./pages/Pending";
import Birthdays from "./pages/Birthdays";
import Dashboard from "./pages/Dashboard";
import Players from "./pages/Players";
import PlayerProfile from "./pages/PlayerProfile";
import PlayerForm from "./pages/PlayerForm";
import Attendance from "./pages/Attendance";
import Matches from "./pages/Matches";
import MatchStats from "./pages/MatchStats";
import Practices from "./pages/Practices";
import Schedule from "./pages/Schedule";
import Announcements from "./pages/Announcements";
import Settings from "./pages/Settings";

import ParentDashboard from "./pages/parent/ParentDashboard";
import ParentPlayerView from "./pages/parent/ParentPlayerView";
import ParentAnnouncements from "./pages/parent/ParentAnnouncements";
import ParentSchedule from "./pages/parent/ParentSchedule";

function RoleHome() {
  const raw = localStorage.getItem("wahdat_user");
  const user = raw ? JSON.parse(raw) : null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "parent" ? "/parent" : "/dashboard"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <InstallPrompt />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Staff (admin/coach) routes */}
          <Route element={<ProtectedRoute staffOnly><Layout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/players" element={<Players />} />
            <Route path="/players/new" element={<PlayerForm />} />
            <Route path="/players/:id" element={<PlayerProfile />} />
            <Route path="/players/:id/edit" element={<PlayerForm />} />
            <Route path="/pending" element={<Pending />} />
            <Route path="/birthdays" element={<Birthdays />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/matches/:id/stats" element={<MatchStats />} />
            <Route path="/practices" element={<Practices />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
            <Route path="/profile" element={<Profile />} />
          </Route>

          {/* Parent portal */}
          <Route element={<ProtectedRoute parentOnly><ParentLayout /></ProtectedRoute>}>
            <Route path="/parent" element={<ParentDashboard />} />
            <Route path="/parent/players/:id" element={<ParentPlayerView />} />
            <Route path="/parent/announcements" element={<ParentAnnouncements />} />
            <Route path="/parent/schedule" element={<ParentSchedule />} />
          </Route>

          <Route path="/" element={<RoleHome />} />
          <Route path="*" element={<RoleHome />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
